const parseNumericSemver = (version) => {
    if (typeof version !== 'string') {
        return null
    }

    const normalizedVersion = version.trim()
    if (! /^\d+(\.\d+){0,2}$/.test(normalizedVersion)) {
        return null
    }

    const versionParts = normalizedVersion
        .split('.')
        .map((part) => Number.parseInt(part, 10))

    while (versionParts.length < 3) {
        versionParts.push(0)
    }

    return versionParts
}

export const isNumericSemverGreaterThanOrEqual = (actualVersion, requiredVersion) => {
    const actualVersionParts = parseNumericSemver(actualVersion)
    const requiredVersionParts = parseNumericSemver(requiredVersion)

    if (actualVersionParts === null || requiredVersionParts === null) {
        return false
    }

    for (let idx = 0; idx < 3; idx++) {
        if (actualVersionParts[idx] > requiredVersionParts[idx]) {
            return true
        }

        if (actualVersionParts[idx] < requiredVersionParts[idx]) {
            return false
        }
    }

    return true
}
